import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';

// Initialize i18n
const initializeI18n = () => {
  i18n
    .use(initReactI18next)
    .init({
      resources: {
        en: {
          translation: enTranslations,
        },
        es: {
          translation: esTranslations,
        },
      },
      lng: localStorage.getItem('i18nextLng') || 'en', // Get from localStorage first
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false, // React already escapes values
      },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
      },
    });
};

// Initialize after DOM is ready
if (typeof window !== 'undefined') {
  initializeI18n();
}

export default i18n;